import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {TasksModelService} from '../../../Models/Tasks/General/tasks-model.service';
import {TaskFilters} from '../../../../Models/Tasks/General/task-filters.model';
import {TaskStoreForm} from '../../../../Models/Tasks/General/task-store.model';
import {FieldDataDto} from '../../../../Models/Tasks/General/task.interface';
import {CommunicationStoreForm} from '../../../../Models/Communication/communication-store.model';

@Injectable({
  providedIn: 'root'
})
export class TasksApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: TasksModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las tareas (Checklists, Appcc, Auditorías)
   *
   */
  public getTasks(filters: TaskFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getChecklist', filters).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los detalles de la tarea
   *
   */
  public getTask(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getThisChecklist', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar una tarea
   *
   */
  deleteTask(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteChecklist', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar valoración de la tarea
   *
   */
  saveAssessTask(params: { id_checklist: number, valoracion: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setValoracionMasiva', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir de forma manual una tarea
   *
   */
  addManualTask(form: TaskStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setChecklistManual', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir una tarea de comunicación (lista)
   *
   */
  setTaskCommunication(form: CommunicationStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setChecklist', form, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir un campo en una tarea de comunicación (lista)
   *
   */
  addFieldTaskCommunication(params: { id_checklist: number, titulo: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCampoChecklist', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar un campo en una tarea de comunicación (lista)
   *
   */
  deleteFieldTaskCommunication(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteCampoChecklist', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Subir imagen en un campo
   *
   */
  setImageField(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCampoImagen', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar valor del campo
   *
   */
  saveValueField(field: FieldDataDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCampo', field, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar valoración
   *
   */
  saveAssessmentField(field: FieldDataDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCampoValoracion', field).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Cerrar tarea
   *
   */
  closeTask(params: { id_checklist: number, reopen: boolean }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('closeChecklist', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Tarea hecha
   *
   */
  doneTask(params: { id_tarea: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('doneTarea', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
